import { createSelector } from 'reselect';

const stateAppSelector = (state) => state.app;

export const appSelector = createSelector(
    [stateAppSelector],
    (app) => {
        return { ...app };
    }
);